export const LOCAL_STORAGE_KEYS = {
  accessToken: "access_token",
  sidebar_menu: "sidebar_menu",
  loginUserDetails: "loginUserDetails",
  selectedCompanyId: "selectedCompanyId",
};

export const url = {
  login: "/auth/login",
  subscriptionplan: "/layout/subscription-plans",
  subscriptionhub: "/layout/subscription",
  signUp: "/auth/register",
  sessionExpired: "/auth/session-expired",
  onboarding: "/onboarding",
  dashboard: "/admin/v2/dashboard",
  campaign: "/layout/campaign",
  campaignDetails: "/layout/campaign/campaign-details",
  videoDetails: "/layout/campaign/campaign-details/video-detail",

  script: "/layout/script-screenplay",
  moodboard: "/layout/moodboard/",
  entityEdit: "/layout/moodboard/entity-edit/",
  storyboard: "/layout/shotlist-storyboard/",
  voiceOver: "/voice-over",
  videoX: "/video-x",
  assetVideoGallary: "/video-gallary",
  billing: "layout/settings-billing",
};

export const assetName = {
  concept: "Concept Note",
  script: "Script Screenplay",
  moodboard: "Moodboard",
  storyboard: "Storyboard",
  aiVisual: "AI Visual",
};

export const fps_master_list = [
  { id: 24, name: "24 fps" },
  { id: 30, name: "30 fps" },
  { id: 60, name: "60 fps" },
  { id: 90, name: "90 fps" },
  { id: 120, name: "120 fps" },
  { id: 144, name: "144 fps" },
];

export const APIURL = {
  //#region Master List
  industryList: "/master-list/industry",
  roleList: "/master-list/roles",
  targetAudience: "/master-list/target-audience",
  videoType: "/master-list/video-type",
  toneAndStyle: "/master-list/tone-style",
  aiModel: "/master-list/aimodels",
  platforms: "/master-list/platforms",
  scriptType: "/master-list/script-types",
  audioDeliveryStyle: "/master-list/audio-delivery-style",
  visualStyle: "/master-list/visual-style",
  setups: "/master-list/setups",
  imageStyle: "/master-list/image-styles",
  conceptManifectMaster: "/master-list/concept-manifest-masters",
  scriptOptions: "/master-list/script-options",
  assetApproved: "/campaign/approved-asset",
  entityRefType: "/master-list/entity-ref-types",
  entityGenOptions: "/master-list/entity-gen-options",
  fetchParameters: "/master-list/fetch-prameters",
  //#endregion

  //#region User Login / Register
  countryList: "/master-list/country",
  sendLoginOTP: "/users/send-email-otp",
  verifyLoginOTP: "/users/verify-login-otp",

  loginWithMagicLink: "/users/send-magic-link",
  loginWithPassword: "/users/login-with-password",
  verifyMagicLink: "/users/verify-magic-link",

  // preCheckUser: "/users/precheck",
  // userSignUp: "/users/signup",
  // userRegistrationVerifyOTPAndUserSignup: "/users/signup",
  // UserRegistrationCompanyDetails: "/users/company-data",
  UserOnboarding: "/users/company-data-onboard",
  basicDetailsUpdate: "/users/basic-detail-update",
  inviteUsers: "/users/invite-users",
  companyUserList: "/users/company-user-list",
  creditBalance: "/users/fetch-credits",
  myorganizations: "/users/myorganizations",
  exitorganizations: "/users/exitorganizations",
  usersdetail: "/users/detail",
  updateuserprofile: "/users/updateprofile",
  //#endregion

  //#region Knowledge Base
  knowledgeBaseSave: "/users/company-knowledge-base",
  //#endregion

  //#region Dashboard APIs
  dashboardStats: "/dashboard/stats",
  dashCampaignList: "/dashboard/compaing-list",
  dashPersonaActivityFeed: "/dashboard/activity-logs",
  dashApprovalReqList: "/dashboard/approval-req-list",
  //#endregion

  //#region Campaign APIs
  createNewCampaign: "/campaign/create-new",
  CampaignList: "/campaign/list",
  campaignDetails: "/campaign/detail",
  campaignTeamList: "/campaign/campaign-team-members",
  camapaignHubStats: "/campaign/stats",

  //#endregion

  //#region Video APIs
  // videodetails: "/campaign/video-detail/",
  // videoProjectCreate: "/campaign/video-create",
  createVideoConceptManifest: "/conceptnote/generate/manifest",
  conceptMenifectDetails: "/conceptnote/manifest/detail/",
  updateManifest: "/conceptnote/manifest/update",
  videoAssetList: "/campaign/video/asset-list/",
  videoRecentActivity: "/campaign/video-activity/",
  //#endregion

  //#region ConceptX APIs
  conceptDetails: "/conceptnote/detail/",
  generateAIConcept: "/conceptnote/generate/req",
  createManualConcept: "/conceptnote/create-mannual",
  conceptFeedbackList: "/conceptnote/feedbacklist",
  approvedConceptNotes: "/conceptnote/approved-list",
  conceptDraftHistory: "/conceptnote/draft-history",
  //#endregion

  //#region Script Writer APIs
  scriptDetails: "/scriptscreenplay/detail/",
  menifestBasicDetails: "/conceptnote/manifest/basic-detail/",
  generateAIScriptV2: "/scriptscreenplay/generate/req/v2",
  updateScriptScene: "/scriptscreenplay/update-scene",
  // generateAIScript: "/scriptscreenplay/generate/req",
  // scriptSave: "/scriptscreenplay/create-mannual",
  // scriptFeedbackList: "/scriptscreenplay/feedbacklist",
  // scriptEntityAdd: "/scriptscreenplay/add-new-entity",
  // scriptDraftHistory: "/scriptscreenplay/draft-history",
  // draftEntities: "/scriptscreenplay/draft-entities",
  //#endregion

  //#region Moodboard APIs
  extractEntities: "/moodboard/extract-entities/",
  saveExtractedEntities: "/moodboard/save-entities/",
  moodboardEntityList: "/moodboard/entity-list/",
  entityDetails: "/moodboard/entity-version/detail",
  editEntityOptions: "/master-list/entity-options",
  saveEntityAttributes: "/moodboard/entity-attributes/save",
  entityReferenceAdd: "/moodboard/add-ref-image",
  referenceImageUpload: "/moodboard/upload-img",
  entityImageGenerate: "/moodboard/generate-img",
  entityRefImageApproved: "/moodboard/approved-image",
  entityImageApprove: "/moodboard/entity-image/approve-reject",
  entityVersionLockUnlock: "/moodboard/entity-version/lock-unlock",
  //#endregion

  //#region Shotlist APIs
  // shotlistDetails: "/shotlist/details/",
  generateShotlistReq: "/shotlist/generate/req",
  createShotlist: "/shotlist/create",
  deleteShotlistShot: "/shotlist/delete-shot/",
  addEditShotlistShot: "/shotlist/update-shot",
  addEditShotlistScene: "/shotlist/add-new-scene",
  swapScenes: "/shotlist/swap-scenes",
  shotlistproductionboard: "/shotlist/production-board",
  shotlistapprovedvideos: "/shotlist/production-board/approvedvideos",
  shotlistvideoapprove: "/shotlist/video/approve",
  shotDetail: "/shotlist/shot/detail",
  updateviewstatusvideo: "/shotlist/ai-video/updateviewstatus",
  //#endregion

  //#region Storyboard APIs
  storyboardDetails: "/shotlist/storyboard-detail/",
  storyboardImageGenerate: "/shotlist/storyboard-image-gen",
  uploadStoryImage: "/shotlist/upload-storyimage",
  uploadvideorefimage: "/shotlist/upload-videorefimage",
  //#endregion

  //#region Voice Over
  createVoiceOverSegment: "/voiceover/create-segment",
  voiceOverDetails: "/voiceover/details/",
  voiceTTSGenerate: "/voiceover/tts-generate",
  voiceList: "/voice/list",
   checkifprevapproved: "/voice/checkifprevapproved",
  approvethetake: "/voice/approvethetake",
  unapprovethetake: "/voice/unapprovethetake",
  voicegeneratespeech: "/voice/generate-speech",
  clearVoiceSegment: "/voiceover/segments-clear",
   scriptbeats: "/voice/script/beats",
  //#endregion

  //#region VideoX
  createVideox: "/shotlist/videox-create",
  videoXDetails: "/shotlist/videox-details/",
  videoXGenerate: "/shotlist/ai-video-generate",
  videoXGeneratev2: "/shotlist/ai-video-generate/v2",
  shotVideoApprove: "/shotlist/shot-video-approve",
  removeVideo: "/shotlist/ai-video-delete/",
  //#endregion

  /**
   * Subscription
   */
  //subscriptionoverview: "/subscription/billing/overview",
  subscriptionusagehistory: "/subscription/usage/history",
  subscriptioncreditpackages: "/subscription/creditpackages",
  subscriptionautocreditpackages: "/subscription/autoreloadcreditpackages",
  getautoreloadoptions: "/subscription/autoreloadoptions",
  subscriptiontopup: "/subscription/topup",
  saveautoreloadoptions: "/subscription/saveautoreloadoptions",
  getsavedautoreloadoptions: "/subscription/getautoreloadoptions",
  plancomparison: "/subscription/plancomparison",
  planlist: "/subscription/planlist",
  subscriptionensurefree: "/subscription/ensure-free",
  paymentcreatesubscription: "/payment/create-subscription",
  paymentcreatetopup: "/payment/create-topup",
  orderdetailsGet: "/payment/order-details",

  //#endregion

  //#endregion
  //subscriptionoverview: "/subscription/billing/overview",

  //
  admin_dashboard : "/dashboard/admin/params",
  admin_companies : "/dashboard/admin/companies",
  admin_companydetail : "/dashboard/admin/company-detail",
  admin_adjust_credits : "/dashboard/admin/adjust-credits",
  admin_teammembers : "/dashboard/admin/team-members",
  admin_teammembersinvites : "/dashboard/admin/team-members/invites",
  admin_transactions : "/dashboard/admin/transactions",
  admin_toggle_suspend : "/dashboard/admin/toggle-suspend",
  admin_company_credit_policy: "/dashboard/admin/company-credit-policy",
  admin_company_user_credit_policy: "/dashboard/admin/company-user-credit-policy",
  admin_company_user_credit_alerts: "/dashboard/admin/company-user-credit-alerts",
  admin_organization_create: "/admin/organizations/create",
  admin_organization_delete: "/admin/organizations/delete",
  admin_organization_invitations: "/admin/organizations/invitations",
  admin_organization_invitations_resend: "/admin/organizations/invitations/resend",
  admin_organization_invitations_delete: "/admin/organizations/invitations/delete",
  admin_organization_remove_member: "/admin/organizations/remove-member",
  admin_organization_member_update_profile: "/admin/organizations/member/update-profile",
  admin_organization_jobs: "/admin/organizations/jobs",
  admin_invite_user : "/users/invite-users",
  admin_resend_invite : "/users/invitation/resend/v2"
  
};
